<template>
  <div class="col-12 ">
    <div class="card mb-5 me-4" style="margin-top: 4rem; overflow: visible">
      <div
        class="card-header p-0 position-relative mt-n4 mx-3 z-index-2"
        style="height: 60px"
      >
        <div
          class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 h-100"
        >
          <h6 class="text-white text-capitalize ps-3 pe-3">
            جدول روابط الابواب والمواد
          </h6>
        </div>
      </div>

      <div class="card-body px-0 pb-2 pe-3">
        <div class="table-responsive p-4">
          <LoadingSpinner
            v-if="loading && chapterSubjects.length === 0"
            message="جاري تحميل البيانات..."
            class="py-5"
          />

          <template v-else>
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th
                    class="text-uppercase text-xxs font-weight-bolder opacity-7"
                  >
                    الباب
                  </th>
                  <th
                    class="text-uppercase text-xxs font-weight-bolder opacity-7"
                  >
                    المادة
                  </th>
                  <th
                    class="text-uppercase text-xxs font-weight-bolder opacity-7"
                  >
                    الحالة
                  </th>
                  <th
                    class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center pe-4"
                  >
                    الإجراءات
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!loading && chapterSubjects.length === 0">
                  <td colspan="4" class="text-center py-4 text-muted">
                    <i class="fas fa-link fa-2x mb-2"></i>
                    <p>لا توجد روابط متاحة</p>
                  </td>
                </tr>

                <template v-if="!loading">
                  <tr v-for="cs in chapterSubjects" :key="cs.id">
                    <td>
                      <div class="d-flex px-3 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-md">
                            {{ cs.chapter?.name || "غير محدد" }}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ cs.subject?.name || "غير محدد" }}
                      </p>
                    </td>
                    <td>
                      <span
                        class="badge"
                        :class="
                          cs.status === 'active' ? 'bg-success' : 'bg-secondary'
                        "
                      >
                        {{ cs.status === "active" ? "نشط" : "غير نشط" }}
                      </span>
                    </td>
                    <td class="align-middle text-end pe-4">
                      <div class="d-inline-flex">
                        <router-link
                          :to="{
                            name: 'chapter-subjects.edit',
                            params: { id: cs.id },
                          }"
                          class="btn btn-link text-secondary p-1 mx-1"
                          title="تعديل"
                        >
                          <i class="fas fa-edit fa-sm"></i>
                        </router-link>
                        <button
                          @click="openDeleteDialog(cs)"
                          class="btn btn-link text-danger p-1 mx-1"
                          title="حذف"
                          :disabled="isProcessing"
                        >
                          <i class="fas fa-trash fa-sm"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from "vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";

defineProps({
  chapterSubjects: {
    type: Array,
    required: true,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const isProcessing = ref(false);
const emit = defineEmits(["delete-chapter-subject"]);

const openDeleteDialog = (chapterSubject) => {
  emit("delete-chapter-subject", chapterSubject);
};
</script>
